if (!customElements.get("gender-dropdown")) {
  class GenderDropdown extends HTMLElement {
    #template;
    #selectField;
    #freeTextField;
    #name;
    #boundHandleChange;

    constructor() {
      super();

      this.#boundHandleChange = this.#handleChange.bind(this);
    }

    connectedCallback() {
      this.#selectField = this.querySelector("select");
      this.#name = this.#selectField.name;
      this.#freeTextField = this.querySelector("#free_text");

      this.#selectField.addEventListener("change", this.#boundHandleChange);
    }

    disconnectedCallback() {
      this.#selectField?.removeEventListener("change", this.#boundHandleChange);
    }

    #handleChange() {
      const selectedOption =
        this.#selectField.options[this.#selectField.selectedIndex];

      if (!selectedOption.hasAttribute("enable-free-text")) {
        // Hide the free text box
        this.#freeTextField.style.display = "none";
        this.#selectField.name = this.#name;
        this.#freeTextField.name = "free_text";
        this.#freeTextField.required = false;
        return;
      }

      // Show the free text box
      this.#freeTextField.style.display = "block";
      this.#freeTextField.name = this.#name;
      this.#freeTextField.required = true;
      this.#selectField.name = "gender_select_field";
    }
  }

  customElements.define("gender-dropdown", GenderDropdown);
}
